export default "__VITE_ASSET__CPOwn1RB__"